export const SN_CATEGORY = 'category'
export const CATEGORY_SET_PRODUCTS = `${SN_CATEGORY}/SET_PRODUCTS`
export const CATEGORY_ADD_PRODUCTS = `${SN_CATEGORY}/ADD_PRODUCTS`
export const CATEGORY_SET_SEARCH_PRODUCTS_STATS = `${SN_CATEGORY}/SET_SEARCH_PRODUCTS_STATS`
export const CATEGORY_ADD_CATEGORIES = `${SN_CATEGORY}/ADD_CATEGORIES`
export const CATEGORY_ADD_CATEGORY = `${SN_CATEGORY}/ADD_CATEGORY`
export const CATEGORY_SET_CATEGORY_FILTERS = `${SN_CATEGORY}/SET_CATEGORY_FILTERS`
export const CATEGORY_ADD_NOT_FOUND_CATEGORY_IDS = `${SN_CATEGORY}/ADD_NOT_FOUND_CATEGORY_IDS`
export const CATEGORY_UPD_MENU_CATEGORIES = `${SN_CATEGORY}/UPD_MENU_CATEGORIES`
export const CATEGORY_SET_MENU_CATEGORIES = `${SN_CATEGORY}/SET_MENU_CATEGORIES`
export const CATEGORY_RESET_MENU_CATEGORIES = `${SN_CATEGORY}/RESET_MENU_CATEGORIES`
export const CATEGORY_SET_MENU_INCLUDE_IN_MENU_CATALOG_REQUEST_KEY = `${SN_CATEGORY}/SET_MENU_INCLUDE_IN_MENU_CATALOG_REQUEST_KEY`
export const CATEGORY_ADD_MENU_CHILDREN_LOADED_PARENTS = `${SN_CATEGORY}/ADD_MENU_CHILDREN_LOADED_PARENTS`
export const CATEGORY_RESET_MENU_CHILDREN_LOADED_PARENTS = `${SN_CATEGORY}/RESET_MENU_CHILDREN_LOADED_PARENTS`
